<template>
  <v-row dense class="mb-3">
    <v-col cols="12" class="d-flex justify-end">
      <v-switch dense
                  class="pa-0 mt-2 mr-2"
                  label="Exibir gráficos"
                  color="primary"
                  v-model="showCharts"/>
      <px-indicadores-fornecedor-filtro @change="onChangeFilter" />
      <px-select-date-range :initial-date-selection="dateSelection"
                            @change="onChangeDate"/>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SET_DATE_ACT } from '@/store/indicadores-fornecedor/actions.type';
import IndicadoresFornecedorFiltro from './IndicadoresFornecedorFiltro.vue';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('indicadoresFornecedor', ['dateSelection']),
    showCharts: {
      get() {
        return this.$store.getters['indicadoresFornecedor/showCharts'];
      },
      set(showCharts) {
        this.$store.dispatch('indicadoresFornecedor/showCharts', showCharts);
      },
    },
  },
  methods: {
    ...mapActions('indicadoresFornecedor', {
      setDateSelection: SET_DATE_ACT,
    }),
    onChangeDate(dateState) {
      this.setDateSelection(dateState);
      this.onChangeFilter();
    },
    onChangeFilter() {
      this.$emit('change');
    },
  },
  components: {
    pxIndicadoresFornecedorFiltro: IndicadoresFornecedorFiltro,
  },
};
</script>
